import React from "react";
import {makeStyles} from "@material-ui/core";
import Button from "@material-ui/core/Button";

export default function ActionCard({name, icon, path}) {

    const classes = useStyles();
    return (
        <Button
            variant="outlined"
            fullWidth
            disableRipple
            startIcon={icon}
            href={path}
            size="large"
            className={classes.root}
        >
            {name}
        </Button>
    )
}


const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(3),
        backgroundColor: 'white'

    }
}));
